import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import Checkbox from '../fields/Checkbox';
import Form from '../partials/Form';

import styles from '../../../styles/forms/form.module.css';

const propTypes = {
    action: PropTypes.string,
    value: PropTypes.shape({}),
    fields: PropTypes.arrayOf(PropTypes.shape({})),
    onComplete: PropTypes.func,
    isCreate: PropTypes.bool,
    className: PropTypes.string,
};

const OrderForm = ({
    action = null,
    fields = null,
    value = null,
    onComplete = null,
    isCreate = true,
    className = null,
}) => {
    const intl = useIntl();
    const { orders = null } = useApi();

    const initialValue = useMemo(() => (isCreate ? value : value), [isCreate, value]);
    const { terms = false } = initialValue || {};
    const [agreed, setAgreed] = useState(terms || false);
    const onAgreed = useCallback(() => setAgreed(!agreed), [agreed, setAgreed]);

    const callback = useCallback(
        (data) => {
            if (agreed) {
                return isCreate ? orders.create(data) : orders.update(data);
            }
            return new Promise();
        },
        [agreed, orders],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Form
                action={action}
                callback={callback}
                fields={fields}
                value={initialValue}
                submitDescription={
                    <div>
                        <p>
                            <FormattedMessage
                                defaultMessage="Please consider this before ordering :"
                                description="Help text"
                            />
                        </p>
                        <ul>
                            <li>
                                <FormattedMessage
                                    defaultMessage="The fee is a for a single projection. Each additional projection needs to be ordered separately."
                                    description="Help text"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    defaultMessage="The projections must be free of charge."
                                    description="Help text"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    defaultMessage="I agree not to share the film medias and deleting it after the projection."
                                    description="Help text"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    defaultMessage="I agree to test my projection tools before the event."
                                    description="Help text"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    defaultMessage="I agree to count the number of spectators and report it after the event to institutions@tenk.ca for statistical purposes."
                                    description="Help text"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    defaultMessage="I agree to pay by credit card or pay my bill within 30 days of ordering."
                                    description="Help text"
                                />
                            </li>
                            <Checkbox
                                id="terms"
                                name="terms"
                                label={intl.formatMessage({
                                    defaultMessage: 'I agree to the terms and conditions',
                                    description: 'Checkbox label',
                                })}
                                value={agreed}
                                onChange={onAgreed}
                            />
                        </ul>
                    </div>
                }
                submitLabel={
                    // eslint-disable-next-line no-nested-ternary
                    !agreed ? (
                        <FormattedMessage
                            defaultMessage="Please accept the terms"
                            description="Button label"
                        />
                    ) : isCreate ? (
                        <FormattedMessage
                            defaultMessage="Create an order"
                            description="Button label"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="Update your order"
                            description="Button label"
                        />
                    )
                }
                disabled={!agreed}
                onComplete={onComplete}
            />
        </div>
    );
};
OrderForm.propTypes = propTypes;

export default OrderForm;
